import { toast } from 'react-toastify';

const OPTIONS = { autoClose: 3500 };

export const notifInfo = (message, options = OPTIONS) => toast.info(message, options);
export const notifSuccess = (message, options = OPTIONS) => toast.success(message, options);
export const notifWarning = (message, options = OPTIONS) => toast.warn(message, options);
export const notifError = (message, options = OPTIONS) => toast.error(message, options);
